import { Component } from "react";
import { withTranslation } from "react-i18next";
import styles from "./SchedaSpecialeArbovirosi.module.css";
import ClassificazioneDelCaso from "./Sezioni/ClassificazioneDelCaso";
import DatiAnagraficiPaziente from "./Sezioni/DatiAnagraficiPaziente";
import DatiCompilatore from "./Sezioni/DatiCompilatore";
import DatiSegnalazione from "./Sezioni/DatiSegnalazione";
import EsamiDiLaboratorio from "./Sezioni/EsamiDiLaboratorio";
import EsitoFollowUp from "./Sezioni/EsitoFollowUp";
import InformazioniCliniche from "./Sezioni/InformazioniCliniche";
import Segnalazioni from "./Sezioni/Segnalazioni";
import LuogoDiEsposizione from "./Sezioni/LuogoDiEsposizione";
import StatoVaccinale from "./Sezioni/StatoVaccinale";
import ViaDiTrasmissione from "./Sezioni/ViaDiTrasmissione";
import InformazioniGenerali from "./Sezioni/InformazioniGenerali";
import SessioneUtente from "../../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../../utils/Ruoli";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import Utils from "../../../../../../utils/Utils";

class SchedaSpecialeArbovirosi extends Component {
    state = {
        schedaSpecialeArbovirosi: {
            malattia:{},
            datiSegnalazione: {},
            datiCompilatore: {},
            datiAnagraficiPaziente: {},
            luogoDiEsposizione: {},
            viaDiTrasmissione: {},
            informazioniGenerali: {},
            statoVaccinale: {},
            informazioniCliniche: {},
            esamiDiLaboratorio: {},
            esitoFollowUp: {},
            classificazioneDelCaso: {}
        },
        validateArbovirosi: {
            datiSegnalazione: "",
            datiCompilatore: "",
            datiAnagraficiPaziente: "",
            luogoDiEsposizione: "",
            viaDiTrasmissione: "",
            informazioniGenerali: "",
            statoVaccinale: "",
            informazioniCliniche: "",
            esamiDiLaboratorio: "",
            esitoFollowUp: "",
            classificazioneDelCaso: ""
        },
        oggettoBe: {},
        corretto: []
    };

    constructor(props) {
        super(props);
        this.setMalattia=this.setMalattia.bind(this);
        this.setDatiSegnalazione = this.setDatiSegnalazione.bind(this);
        this.setDatiCompilatore = this.setDatiCompilatore.bind(this);
        this.setDatiAnagraficiPaziente = this.setDatiAnagraficiPaziente.bind(this);
        this.setLuogoDiEsposizione = this.setLuogoDiEsposizione.bind(this);
        this.setViaDiTrasmissione = this.setViaDiTrasmissione.bind(this);
        this.setInformazioniGenerali = this.setInformazioniGenerali.bind(this);
        this.setStatoVaccinale = this.setStatoVaccinale.bind(this);
        this.setInformazioniCliniche = this.setInformazioniCliniche.bind(this);
        this.setEsamiDiLaboratorio = this.setEsamiDiLaboratorio.bind(this);
        this.setEsitoFollowUp = this.setEsitoFollowUp.bind(this);
        this.setClassificazioneDelCaso = this.setClassificazioneDelCaso.bind(this);

        this.updateSezione = this.updateSezione.bind(this);
        this.updateSezioneConValidazione = this.updateSezioneConValidazione.bind(this);
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        this.props.setSchedaSpecialeECorretto(this.state.oggettoBe, "", this.state.corretto);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.oggettoBe !== this.state.oggettoBe ||
            prevState.validateArbovirosi !== this.state.validateArbovirosi ||
            prevState.corretto !== this.state.corretto
        ) {
            this.props.setSchedaSpecialeECorretto(
                this.state.oggettoBe,
                this.validate(),
                this.state.corretto
            );
        }
    }

    validate() {
        const validate = this.state.validateArbovirosi;

        for (let key in validate) {
            if (validate[key]) {
                return validate[key];
            }
        }

        return "";
    }

    setMalattia(dati, datiBe) {
        this.updateSezione("malattia", dati, datiBe);
    }

    setDatiSegnalazione(dati, datiBe) {
        this.updateSezione("datiSegnalazione", dati, datiBe);
    }

    setDatiCompilatore(dati, datiBe) {
        this.updateSezione("datiCompilatore", dati, datiBe);
    }

    setDatiAnagraficiPaziente(dati, validateStr, datiBe) {
        this.updateSezioneConValidazione("datiAnagraficiPaziente", dati, datiBe, validateStr);
    }

    setLuogoDiEsposizione(dati, datiBe) {
        this.updateSezione("luogoDiEsposizione", dati, datiBe);
    }

    setViaDiTrasmissione(dati, datiBe) {
        this.updateSezione("viaDiTrasmissione", dati, datiBe);
    }

    setInformazioniGenerali(dati, datiBe) {
        this.updateSezione("informazioniGenerali", dati, datiBe);
    }

    setStatoVaccinale(dati, datiBe) {
        this.updateSezione("statoVaccinale", dati, datiBe);
    }

    setInformazioniCliniche(dati, datiBe) {
        this.updateSezione("informazioniCliniche", dati, datiBe);
    }

    setEsamiDiLaboratorio(dati, datiBe) {
        this.updateSezione("esamiDiLaboratorio", dati, datiBe);
    }

    setEsitoFollowUp(dati, datiBe) {
        this.updateSezione("esitoFollowUp", dati, datiBe);
    }

    setClassificazioneDelCaso(dati, datiBe) {
        this.updateSezione("classificazioneDelCaso", dati, datiBe);
    }

    updateSezione(nome, dati, datiBe) {
        this.setState(
            prevState => ({
                schedaSpecialeArbovirosi: {
                    ...prevState.schedaSpecialeArbovirosi,
                    [nome]: dati || {}
                },
                oggettoBe: {
                    ...prevState.oggettoBe,
                    [nome]: datiBe
                }
            }),
            this.controlloCorrettezza
        );
    }

    updateSezioneConValidazione(nome, dati, datiBe, validateStr) {
        this.setState(
            prevState => ({
                schedaSpecialeArbovirosi: {
                    ...prevState.schedaSpecialeArbovirosi,
                    [nome]: dati || {}
                },
                oggettoBe: {
                    ...prevState.oggettoBe,
                    [nome]: datiBe
                },
                validateArbovirosi: {
                    ...prevState.validateArbovirosi,
                    [nome]: validateStr
                }
            }),
            this.controlloCorrettezza
        );
    }

    controlloCorrettezza() {
        const scheda = this.state.schedaSpecialeArbovirosi;
        let textList = [];

        Object.keys(scheda).forEach(key => {
            if (scheda[key] && scheda[key].corretto && scheda[key].corretto.length > 0) {
                textList = textList.concat(Utils.eliminaNullArray(scheda[key].corretto));
            }
        });

        this.setState({ corretto: textList });
    }

    render() {
        const { t, segnalazioneCopia, datiPaziente, classificazioneDelCaso } = this.props;

        const isDisabled =
            (segnalazioneCopia && segnalazioneCopia.migrazione) ||
            SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione ||
            (
                segnalazioneCopia &&
                (
                    segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice
                )
            );

        return (
            <div className={isDisabled ? "visualizzazione" : ""}>
                <fieldset disabled={isDisabled}>
                    <Segnalazioni
                        malattia={segnalazioneCopia?.malattia}
                        segnalazioneCopia={segnalazioneCopia}
                        setMalattia={this.setMalattia}
                    />

                    <h6>{t("Dati Segnalazione")}</h6>
                    <hr className={styles.hr} />
                    <DatiSegnalazione
                        segnalazioneCopia={segnalazioneCopia}
                        setDatiSegnalazione={this.setDatiSegnalazione}
                    />

                    <h6>{t("Dati Compilatore")}</h6>
                    <hr className={styles.hr} />
                    <DatiCompilatore
                        segnalazioneCopia={segnalazioneCopia}
                        setDatiCompilatore={this.setDatiCompilatore}
                    />

                    <h6>{t("Dati Anagrafici Paziente")}</h6>
                    <hr className={styles.hr} />
                    <DatiAnagraficiPaziente
                        datiPaziente={datiPaziente}
                        segnalazioneCopia={segnalazioneCopia}
                        setDatiAnagraficiPaziente={this.setDatiAnagraficiPaziente}
                    />

                    <h6>{t("Luogo di Esposizione")}</h6>
                    <hr className={styles.hr} />
                    <LuogoDiEsposizione
                        segnalazioneCopia={segnalazioneCopia}
                        setLuogoDiEsposizione={this.setLuogoDiEsposizione}
                    />

                    <h6>{t("Via di Trasmissione")}</h6>
                    <hr className={styles.hr} />
                    <ViaDiTrasmissione
                        segnalazioneCopia={segnalazioneCopia}
                        setViaDiTrasmissione={this.setViaDiTrasmissione}
                    />

                    <h6>{t("Informazioni Generali")}</h6>
                    <hr className={styles.hr} />
                    <InformazioniGenerali
                        segnalazioneCopia={segnalazioneCopia}
                        setInformazioniGenerali={this.setInformazioniGenerali}
                    />

                    <h6>{t("Stato Vaccinale")}</h6>
                    <hr className={styles.hr} />
                    <StatoVaccinale
                        segnalazioneCopia={segnalazioneCopia}
                        setStatoVaccinale={this.setStatoVaccinale}
                    />

                    <h6>{t("Informazioni Cliniche")}</h6>
                    <hr className={styles.hr} />
                    <InformazioniCliniche
                        segnalazioneCopia={segnalazioneCopia}
                        setInformazioniCliniche={this.setInformazioniCliniche}
                    />

                    <h6>{t("Esami di Laboratorio")}</h6>
                    <hr className={styles.hr} />
                    <EsamiDiLaboratorio
                        segnalazioneCopia={segnalazioneCopia}
                        setEsamiDiLaboratorio={this.setEsamiDiLaboratorio}
                    />

                    <h6>{t("Esito Follow UP")}</h6>
                    <hr className={styles.hr} />
                    <EsitoFollowUp
                        segnalazioneCopia={segnalazioneCopia}
                        setEsitoFollowUp={this.setEsitoFollowUp}
                    />

                    <h6>{t("Classificazione del caso")}</h6>
                    <hr className={styles.hr} />
                    <ClassificazioneDelCaso
                        segnalazioneCopia={segnalazioneCopia}
                        malattiacodice={segnalazioneCopia?.malattia}
                        setClassificazioneDelCaso={this.setClassificazioneDelCaso}
                        informazioniCliniche={this.state.schedaSpecialeArbovirosi.informazioniCliniche}
                        informazioniGenerali={this.state.schedaSpecialeArbovirosi.informazioniGenerali}
                        donatore={this.state.schedaSpecialeArbovirosi.informazioniGenerali?.donatore} />

                </fieldset>
            </div>
        );
    }
}

export default withTranslation('common')(SchedaSpecialeArbovirosi);